import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import LayoutMixin from '@/views/dashboard/mixins/layout';
import template from '@/../templates/dashboard/widgets/device-count.hbs';

    // Map type to a more readable string
    var readable = {
        'development_devicegroup': 'Development Devices',
        'pre_factoryfixture_devicegroup': 'Test Fixture Devices',
        'pre_production_devicegroup': 'Test Production Devices',
        'production_devicegroup': 'Production Devices',
        'factoryfixture_devicegroup': 'Fixture Devices',
        'pre_dut_devicegroup': 'Test DUT Devices',
        'dut_devicegroup': 'DUT Devices'
    };

    var DeviceCountWidget = Marionette.View.extend(LayoutMixin).extend({
        className: function(){ return "widget device-count " + this.getWidth(); },
        template: Handlebars.compile(template),
        modelEvents: {
            'change': 'render'
        },
        initialize: function() {
            var self = this;

            // Use old counts method for production
            if (this.model.type === 'production_devicegroup' || this.model.type === 'factoryfixture_devicegroup' || this.model.type === 'dut_devicegroup') {
                this.model.counts.fetch().then(function () { self.render(); });
            } else {
                this.devcounts = this.model.rel.get('product').devcounts;

                // Since devcounts is not the view's model, we need to attach a listener to it
                this.listenTo(this.devcounts, 'update', this.render());
                // Render after fetching
                this.devcounts.fetch().then(function () { self.render(); });
            }
        },
        templateContext: function() {
            var strings = {
                title  : readable[this.model.type]
            };

            // Will need to assume we have a model which has
            // a value with the number of production devices
            var last_calculated = (this.devcounts) ? this.devcounts.get('updated') : this.model.counts.get('updated');
            var dcs,
                dc,
                pdc;

            if ( this.devcounts ) {
                dcs = this.devcounts.get('items');
                if ( dcs ) {
                    dc = dcs[this.model.id];
                }
            }

            if ( this.model.counts && this.model.counts.get('devices')) {
                pdc = this.model.counts.get('devices');
            }

            return {
                devcounts: (dc) ? dc.devices : 0,
                s : strings,
                width: this.getWidth(),
                count: pdc || 0,
                last_calculated : last_calculated
            };
        }
    });

    export default DeviceCountWidget;

